'use client'
import { HEADER_MENU } from '@/config/global-config'
import { TypeLink, usePathname } from '@/libs/i18n/routing'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
export const NavHeader = () => {
  const t = useTranslations()
  const activeRoute = usePathname()

  return (
    <Stack direction="row">
      {HEADER_MENU?.map((item) => (
        <Link key={item?.key} href={item?.link as TypeLink}>
          <Box
            sx={{
              p: { xs: '10px 15px', lg: '10px 20px' },
              transition: 'background-color 0.3s',
              '&:hover': {
                backgroundColor: 'primary.main',
              },
              backgroundColor: activeRoute === item?.link ? 'primary.main' : 'transparent',
            }}
          >
            <Typography
              component={'span'}
              sx={{
                fontSize: { xs: '0.875rem', lg: '1rem' },
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                color: 'white',
                fontWeight: 700,
              }}
            >
              {/* @ts-ignore */}
              {t(`Breadcrumb.${item.key}`)}
            </Typography>
          </Box>
        </Link>
      ))}
    </Stack>
  )
}
